import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Company } from '../../../../shared/models/company/company.model';
import { RolType } from '../../../../shared/models/types/rol.types';
import { CompanyService } from '../../../../shared/services/company/company.service';
import { TranslatorService } from '../../../../shared/services/utils/translator.service';
import { DropdownBaseComponent } from '../dropdown-base.component';
import { DropDownService } from '../dropdown.service';

@Component({
  selector: 'ngx-company-selection-dropdown',
  templateUrl: '../template-dropdown.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CompanySelectionDropdownComponent extends DropdownBaseComponent implements OnInit {

  rolType: RolType = new RolType();
  @Input() companies: Company[];

  constructor(
    private readonly dropdownService: DropDownService,
    private readonly companyService: CompanyService,
    protected readonly translatorService: TranslatorService) {
    super(translatorService);
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.dropDownSettings = this.dropdownService.getConfiguration(this.singleSelection);
    if (!this.companies) {
      this.companyService.getUserLoggedCompanies$().subscribe(res => {
        this.itemsData = res.companies;
        this.dropdownService.getCompanyCompleted.emit();
      });
    } else {
      this.itemsData = this.companies;
      this.dropdownService.getCompanyCompleted.emit();
    }
  }
}
